import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import { Step, StepLabel, Stepper } from '@mui/material';
import Completed from '../../../../assets/images/Completed.svg';
import firstImage from '../../../../assets/images/warehouse.png';
import secondImage from '../../../../assets/images/information.png';
import Select from 'react-select';
import { faArrowLeft, faChevronDown, faChevronUp, faCircleXmark, faPlus, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Badge, Button, Col, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { GETSCHEDULEDTRUCKS, STATIONGRID, TRUCKERRATELIST, TRUCKORDERSAVE, TRUCKERGRID } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios';
import AddStationAddress from '../../../../Components/common/AddStationAddress';
import AddStation from '../../../../Components/common/AddStation';
import { toast } from 'react-toastify';
import Docmnt from '../../../../assets/images/google-docs.png';
import { MultiSelect } from 'react-multi-select-component';
import Trash from "../../../../assets/images/trash.png";
import { GETDESTINATION, AWBADD, AWBMSG, GETSHC, GETOWNERCODE, ADDAWB } from '../../../../Utils/conts.js';
const OrderTruck = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [finishStep, setFinishStep] = useState(false);
    const [bookingTruckList, setBookingTruckList] = useState([]);
    const [boardPoint, setBoardPoint] = useState([]);
    const [offPoint, setOffPoint] = useState([]);
    const [bpaddress, setBpaddress] = useState([]);
    const [offPointAddress, setOffPointAddress] = useState([]);
    const [selected, setSelected] = useState([]);
    const [rateChart, setRateChart] = useState([]);
    const [truckerList, setTruckerList] = useState();
    const [showAddStation, setShowAddStation] = useState(false);
    const [showAddStationAddress, setShowAddStationAddress] = useState(false);
    const [addressType, setAddressType] = useState('');
    const [value, setValue] = useState('');
    const [files, setFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const fileInputRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [vpIndex, setVpIndex] = useState('');
    const [getShc, setGetShc] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const isMounted = useRef(false);
    const [getDestination, setGetDestination] = useState([]);
    const dayNames = {
        '0': 'Sunday',
        '1': 'Monday',
        '2': 'Tuesday',
        '3': 'Wednesday',
        '4': 'Thursday',
        '5': 'Friday',
        '6': 'Saturday'
    };
    const currencyOptions = [
        { value: "EUR", label: "EUR (€) - Euro", symbol: '€' },
        { value: "USD", label: "USD ($) - US Dollar", symbol: '$' },
        { value: "PHP", label: "PHP (₱) - Philippine Peso", symbol: '₱' },
        { value: "JPY", label: "JPY (¥) - Japanese Yen", symbol: '¥' },
        { value: "GBP", label: "GBP (£) - British Pound", symbol: '£' },
        { value: "AUD", label: "AUD (A$) - Australian Dollar", symbol: 'A$' },
        { value: "CHF", label: "CHF (Fr.) - Swiss Franc", symbol: 'Fr.' },
        { value: "CAD", label: "CAD (C$) - Canadian Dollar", symbol: 'C$' },
        { value: "MXN", label: "MXN ($) - Mexican Peso", symbol: '$' },
        { value: "CNY", label: "CNY (¥) - Chinese Yuan", symbol: '¥' },
        { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar", symbol: 'NZ$' },
        { value: "SEK", label: "SEK (kr) - Swedish Krona", symbol: 'kr' },
        { value: "RUB", label: "RUB (₽) - Russian Ruble", symbol: '₽' },
        { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar", symbol: 'HK$' },
        { value: "NOK", label: "NOK (kr) - Norwegian Krone", symbol: 'kr ' },
        { value: "SGD", label: "SGD (S$) - Singapore Dollar", symbol: 'S$' },
        { value: "TRY", label: "TRY (₺) - Turkish Lira", symbol: '₺' },
        { value: "KRW", label: "KRW (₩) - South Korean Won", symbol: '₩' },
        { value: "ZAR", label: "ZAR (R) - South African Rand", symbol: 'R' },
        { value: "BRL", label: "BRL (R$) - Brazilian Real", symbol: 'R$' },
        { value: "INR", label: "INR (₹) - Indian Rupee", symbol: '₹' },
        { value: "SAR", label: "SAR (﷼) - Saudi Riyal", symbol: '﷼' },
        { value: "DKK", label: "DKK (kr) - Danish Krone", symbol: 'kr' },
        { value: "RON", label: "RON (lei) - Romanian Leu", symbol: 'lei' },
        { value: "XAF", label: "XAF (Fr) - Central African CFA Franc", symbol: 'Fr' },
        { value: "XOF", label: "XOF (Fr) - West African CFA Franc", symbol: 'Fr' },
        { value: "DOP", label: "DOP (RD$) - Dominican Peso", symbol: 'RD$)' },
        { value: "HTG", label: "HTG (G) - Haitian Gourde", symbol: 'G' },
        { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar", symbol: 'Bds$' },
        { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar", symbol: 'TT$)' },
        { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar", symbol: 'EC$' },
        { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder", symbol: 'ƒ' },
        { value: "COP", label: "COP (COL$) - Colombian Peso", symbol: 'COL$' },
        { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights", symbol: 'SDR' },
        { value: "XBT", label: "XBT (₿) - Bitcoin", symbol: '₿' },
        { value: "WGH", label: "WGH - West German Hard Currency", symbol: 'WGH' },
    ];
    const ltlOptoins = [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
    ];
    const initialFormData = {
        type_of_truck: 'B',
        bookingTruck_type: 'E',
        new_schedule_data: {
            trip_type: 'O',
        },
        adr: '1',
        extra_truck_specification: [],
        coload: [],
        carriers: [],
        filesWithBase64: [],
        temperature_range_one_start: '0',
        temperature_range_one_end: '0',
        temperature_range_two_start: '0',
        temperature_range_two_end: '0',
        temperature_range_three_start: '0',
        temperature_range_three_end: '0',
        rateType: 'FR',
    };
    const localdata = JSON.parse(localStorage.getItem('OT'));
    const localdataTD = JSON.parse(localStorage.getItem('TD'));
    const [localFormData, setLocalFormData] = useState({
        type_of_truck: 'B',
        bookingTruck_type: 'E',
        new_schedule_data: {
            trip_type: 'O',
        },
        coload: [],
        adr: '1',
        driver_number: '1',
        extra_truck_specification: [],
        carriers: [],
        filesWithBase64: [],
        temperature_range_one_start: '0',
        temperature_range_one_end: '0',
        temperature_range_two_start: '0',
        temperature_range_two_end: '0',
        temperature_range_three_start: '0',
        temperature_range_three_end: '0',
        rateType: 'FR',
    });
    useEffect(() => {
        stationDataApi();
        if (localdata) {
            setLocalFormData(localdata);
            fetchTruckRateList({ 'date': localdata.existing_date });
        }
        if (localdataTD) {
            setLocalFormData({
                type_of_truck: 'B',
                existing_date: localdataTD.arrival_date,
            });
            fetchTruckRateList({ 'date': localdata?.arrival_date });
        }
        const checkOT = localStorage.getItem('OT');
        const transormData = JSON.parse(checkOT)
        if (checkOT) {
            setLocalFormData({ ...localFormData, transormData });
        }
        // reloadRates();
        reloadtruckerList();

        const storedData = JSON.parse(localStorage.getItem('OT'));
        if (storedData) {
            // console.log("🚀 ~ useEffect ~ storedData:", storedData.step)
            setIsEdit(true)
            // const eData = storedData.innerData;
            const transformData = {
                ...storedData,
                existing_date: storedData.departure_date,
                // carriers: [],
                // rateType: 'FM',
            }
            setLocalFormData(transformData);
            setActiveStep(storedData.step);
        }
    }, [])
    const [steps, setSteps] = useState([
        { label: 'Type of Truck', icon: <img src={firstImage} alt="Truck" /> },
        { label: 'Truck Information', icon: <img src={secondImage} alt="Information" /> }
    ]);
    const [coloadData, setColoadData] = useState([])
    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('OT'));
        if (!storedData) {
            if (localFormData.type_of_truck === 'A') { // Ad Hoc
                setSteps([
                    { label: 'Type of Truck', icon: <img src={firstImage} alt="Truck" /> },
                    { label: 'Shipment Information', icon: <img src={secondImage} alt="Shipment" /> },
                    { label: 'Truck Information', icon: <img src={secondImage} alt="Information" /> }
                ]);
            } else { // Booking Truck
                setSteps([
                    { label: 'Type of Truck', icon: <img src={firstImage} alt="Truck" /> },
                    { label: 'Truck Information', icon: <img src={secondImage} alt="Information" /> }
                ]);
            }

            // Reset to first step when truck type changes
            setActiveStep(0);
        }
    }, [localFormData.type_of_truck]);
    const stepNext = () => {
        if (!localFormData.truck_no) {
            toast.error("Please Add Operational Truck");
            return;
        }
        if (localFormData.type_of_truck === 'A') {
            // if (!localFormData.new_schedule_data.booking_type) {
            //     toast.error("Please Add Booking Type");
            //     return;
            // }
            if (!localFormData.board_point) {
                toast.error("Please Add Boardpoint");
                return;
            }
            if (!localFormData.boardpoint_address_name) {
                toast.error("Please Add Boardpoint Address");
                return;
            }
            if (!localFormData.off_point) {
                toast.error("Please Add Offpoint");
                return;
            }
            if (!localFormData.offpoint_address_name) {
                toast.error("Please Add Offpoint Address");
                return;
            }
        }
        if (!localFormData.departure_date_time) {
            toast.error("Please Add Date");
            return;
        }

        // if (!localFormData.departure_time) {
        //     toast.error("Please Add Time");
        //     return;
        // }
        if (localFormData.type_of_truck === 'B') {
            if (!localFormData.service_type) {
                toast.error("Please Select Truck Load");
                return;
            }
        }
        if (!localFormData.driver_number) {
            toast.error("Please Select Number of Drivers");
            return;
        }
        if (!localFormData.adr) {
            toast.error("Please Select ADR Required");
            return;
        }
        if (!localFormData.truck_height) {
            toast.error("Please Add Truck Height");
            return;
        }
        if (!localFormData.rollerbed) {
            toast.error("Please Add Rollerbed Required");
            return;
        }
        if (!localFormData.temperature_control) {
            toast.error("Please Select Temparature");
            return;
        }
        if (localFormData.temperature_control === 'TC') {
            if (parseFloat(localFormData.temperature_range_one_start) >= parseFloat(localFormData.temperature_range_one_end)) {
                toast.error("Temperature Range Start should be less than End");
                return;
            }
        }
        if (localFormData.temperature_control === 'MC') {
            if ((parseFloat(localFormData.temperature_range_two_start) >= parseFloat(localFormData.temperature_range_two_end)) || (parseFloat(localFormData.temperature_range_three_start) >= parseFloat(localFormData.temperature_range_three_end))) {
                toast.error("Temperature Range Start should be less than End");
                return;
            }
        }
        if (!localFormData.truck_material) {
            toast.error("Please Select Truck Material");
            return;
        }
        if (localFormData.truck_material === 'CS' || localFormData.truck_material === 'FT') {
            if (localFormData.extra_truck_specification.length <= 0) {
                toast.error("Please Select Extra Truck Option");
                return;
            }
        }
        reloadRates();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    const stepBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
    // const handleFinish = async () => {
    //     var allfiles = [];
    //     if (localFormData.filesWithBase64.length > 0) {
    //         localFormData.filesWithBase64.forEach(element => {
    //             allfiles.push(element.base64)
    //         });
    //     }
    //     let temp = [];
    //     if (localFormData.temperature_control == "MC") {
    //         let temp1 = localFormData.temperature_range_two_start + " - " + localFormData.temperature_range_two_end;
    //         let temp2 = localFormData.temperature_range_three_start + " - " + localFormData.temperature_range_three_end;
    //         temp = [{ temp1 }, { temp2 }];
    //         setLocalFormData({ ...localFormData, temperature: temp });
    //     }
    //     if (localFormData.temperature_control == "TC") {
    //         let temp1 = localFormData.temperature_range_one_start + " - " + localFormData.temperature_range_one_end;
    //         temp = [{ temp1 }];
    //         setLocalFormData({ ...localFormData, temperature: temp });
    //     }
    //     if (inputGroups.length > 0) {
    //         const coload = inputGroups.map(({ date, bookingtruck_date_id, positions }) => ({
    //             date,
    //             bookingtruck_date_id,
    //             positions,
    //         }));

    //         setLocalFormData((prevState) => ({
    //             ...prevState,
    //             coload,
    //         }));
    //     }
    //     if (localFormData.new_schedule_data.viapoints?.length > 0) {
    //         const viapoints = localFormData.new_schedule_data.viapoints?.map(({ viaPoint, viaPointAddress }) => ({
    //             viaPoint,
    //             viaPointAddress,
    //         }));

    //         setLocalFormData({
    //             ...localFormData,
    //             new_schedule_data: {
    //                 ...localFormData.new_schedule_data,
    //                 viapoints
    //             }
    //         });
    //     }
    //     console.log('Finish', localFormData);

    //     // let transData = {};
    //     // if (inputGroups.length > 0) {
    //     //     const coload = inputGroups.map(({ date, bookingtruck_date_id, positions }) => ({
    //     //         date,
    //     //         bookingtruck_date_id,
    //     //         positions,
    //     //     }));

    //     //     transData = { ...localFormData, coload }
    //     // }
    //     // console.log('Finish 0=>', transData);

    //     // try {
    //     //     const res = await withRFSToken.post(TRUCKORDERSAVE, localFormData)
    //     //         .then(function (res) {
    //     //             if (res.data.response_code == 200) {
    //     //                 toast.success(res.data.response_msg);
    //     //                 setTimeout(() => {
    //     //                     window.location.href = "TruckOrder";
    //     //                 }, 1000);
    //     //             } else {
    //     //                 toast.error(res.data.response_msg);
    //     //             }
    //     //         });

    //     // } catch (error) {
    //     //     console.error('Error fetching data:', error);
    //     // }
    // }\

    const handleFinish = async () => {
        console.log(formData);
        if (!localFormData.rateType) {
            toast.error("Please Add Rate ");
            return;
        }
        if (!localFormData.carriers) {
            toast.error("Please Add Carriers");
            return;
        }
        setIsLoading(true);
        // Collect all files

        var allfiles = [];
        if (localFormData.filesWithBase64?.length > 0) {
            localFormData.filesWithBase64.forEach(element => {
                allfiles.push(element.base64);
            });
        }

        // Handle temperature control data
        let temp = [];
        if (localFormData.temperature_control === "MC") {
            let temp1 = localFormData.temperature_range_two_start + " - " + localFormData.temperature_range_two_end;
            let temp2 = localFormData.temperature_range_three_start + " - " + localFormData.temperature_range_three_end;
            temp = [{ temp1 }, { temp2 }];
        } else if (localFormData.temperature_control === "TC") {
            let temp1 = localFormData.temperature_range_one_start + " - " + localFormData.temperature_range_one_end;
            temp = [{ temp1 }];
        }

        // Handle coload data
        let coload = [];
        if (inputGroups.length > 0) {
            coload = inputGroups.map(({ date, bookingtruck_date_id, positions }) => ({
                date,
                bookingtruck_date_id,
                positions,
            }));
        } else {
            coload = localFormData.coload;
        }

        // Handle viapoints data
        let viapoints = [];
        if (localFormData.new_schedule_data.viapoints?.length > 0) {
            viapoints = localFormData.new_schedule_data.viapoints?.map(({ viaPoint, viaPointAddress }) => ({
                viaPoint,
                viaPointAddress,
            }));
        }

        // Update state in a single batch to avoid multiple re-renders
        const payLoad = {
            ...localFormData,
            temperature: temp,
            coload,
            new_schedule_data: {
                ...localFormData.new_schedule_data,
                viapoints,
            },
            'awbs': formData
        }
        console.log('payLoad', payLoad);

        // setLocalFormData((prevState) => {
        //     const updatedState = {
        //         ...prevState,
        //         temperature: temp,
        //         coload,
        //         new_schedule_data: {
        //             ...prevState.new_schedule_data,
        //             viapoints,
        //         },
        //     };

        //     // Log the updated state after all updates are applied
        //     console.log('Finish', updatedState);

        //     return updatedState;
        // });

        // Uncomment and use this block if you want to send the data to an API

        try {
            const res = await withRFSToken.post(TRUCKORDERSAVE, payLoad)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        toast.success(res.data.response_msg);
                        setTimeout(() => {
                            window.location.href = "TruckOrder";
                        }, 1000);
                        setIsLoading(false);
                    } else {
                        toast.error(res.data.response_msg);
                        setIsLoading(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleStepClick = async () => {

    }
    const tempChange = (key, e) => {
        // setLocalFormData({ ...localFormData, [type]: e.target.value });
        const numericValue = parseFloat(e.target.value);
        setLocalFormData((prev) => {
            if (!isNaN(numericValue)) {
                if (key.endsWith('_end')) {
                    const startKey = key.replace('_end', '_start');
                    return {
                        ...prev,
                        [key]: Math.max(prev[startKey], Math.min(numericValue, 18)), // Clamp between start value and 18
                    };
                } else {
                    return {
                        ...prev,
                        [key]: Math.max(0, Math.min(numericValue, 18)), // Clamp between 0 and 18
                    };
                }
            } else {
                return {
                    ...prev,
                    [key]: key.endsWith('_end') ? prev[key.replace('_end', '_start')] : 0, // Reset to start value or 0
                };
            }
        });

    }
    const handleIncrease = (key, maxValue) => {
        // let temp = localFormData[type];
        // temp++;
        // setLocalFormData({ ...localFormData, [type]: temp });

        setLocalFormData((prev) => {
            let currentValue = parseFloat(prev[key]) || 0;
            if (key.endsWith('_end')) {
                const startKey = key.replace('_end', '_start');
                currentValue = Math.max(prev[startKey], currentValue); // Ensure it respects the start value
            }
            return {
                ...prev,
                [key]: Math.min(currentValue + 1, maxValue), // Increment and ensure it doesn't exceed max value
            };
        });
    }
    const handleDecrease = (key, minValue) => {
        // let temp = localFormData[type];
        // temp--;
        // setLocalFormData({ ...localFormData, [type]: temp });

        setLocalFormData((prev) => {
            let currentValue = parseFloat(prev[key]) || 0;
            if (key.endsWith('_end')) {
                const startKey = key.replace('_end', '_start');
                minValue = prev[startKey]; // Set minValue to the corresponding start value
            }
            return {
                ...prev,
                [key]: Math.max(currentValue - 1, minValue), // Decrement and ensure it doesn't go below min value
            };
        });
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'type_of_truck') {
            setSelectedIndex(null);
            setBookingTruckList([]);
            if (value === 'A') {
                setInputGroups([]);
                setLocalFormData({
                    ...localFormData,
                    type_of_truck: 'A',
                    bookingTruck_type: 'N',
                    new_schedule_data: {
                        trip_type: 'O',
                        viapoints: [],
                    },
                    // adr: '1',
                    // driver_number: '1',
                    // extra_truck_specification: [],
                    carriers: [],
                    // filesWithBase64: [],
                    // temperature_range_one_start: '0',
                    // temperature_range_one_end: '0',
                    // temperature_range_two_start: '0',
                    // temperature_range_two_end: '0',
                    // temperature_range_three_start: '0',
                    // temperature_range_three_end: '0',
                    rateType: 'FR',
                });
            } else {
                setLocalFormData(localFormData);
            }
        }

        const nameParts = name.split('.');

        setLocalFormData(prevState => {
            const updatedFormData = { ...prevState };

            if (nameParts.length > 1) {
                let currentLevel = updatedFormData;
                for (let i = 0; i < nameParts.length - 1; i++) {
                    const part = nameParts[i];
                    if (!currentLevel[part]) {
                        currentLevel[part] = {};
                    }
                    currentLevel = currentLevel[part];
                }
                currentLevel[nameParts[nameParts.length - 1]] = value;
            } else {
                console.log('dddddd', name);

                updatedFormData[name] = value;
            }
            if (name === 'adr' && value === '1') {
                // updatedFormData.driver_number = '1';
            }

            return updatedFormData;
        });

        // Other existing logic
        if (nameParts[1] === "departure_date" || nameParts[1] === "departure_time") {
            setLocalFormData({ ...localFormData, [nameParts[1]]: value });
        }

        if (name === "existing_date") {
            fetchTruckRateList({ 'date': e.target.value });
        }

        if (name === "bookingTruck_type" && value === "N") {
            stationDataApi();
        }
    };

    const bookingTruckChange = (value, index) => {
        setSelectedIndex(index);
        if (inputGroups.length) {
            const findMatch = inputGroups.find(itm => itm.bookingtruck_date_id === coloadData[0].bookingtruck_date_id)

            setLocalFormData({
                ...localFormData,
                bookingtruck_id: value.bookingtruck_id,
                bookingtruck_date_id: value.bookingtruck_date_id,
                // new_schedule_data: {
                //     ...localFormData.new_schedule_data,
                //     bookingtruck_no: value.bookingtruck_no,
                //     bookingtruck_date_id: value.bookingtruck_date_id,
                //     departure_date: value.departure_date,
                //     departure_time: value.departure_time,
                // },
                // m 11.11.25
                coload: [{
                    date: value.departure_date,
                    bookingtruck_date_id: value.bookingtruck_date_id,
                    truckLabel: value.bookingtruck_no,
                    positions: value?.positions || '0',
                }],
                departure_date_time: value.departure_date_time,
                arrival_date_time: value.arrival_date_time,
                // departure_date: value.departure_date,
                board_point: value.board_point,
                off_point: value.off_point,
                // truck_no: value.bookingtruck_no,

            });
            setInputGroups((prevGroups) =>
                prevGroups.map((group, i) =>
                    i === 0
                        ? {
                            ...group,
                            date: value.departure_date,
                            bookingtruck_date_id: value.bookingtruck_date_id,
                            truckLabel: value.bookingtruck_no,
                            positions: value?.positions || '0',
                        }
                        : group
                )
            );
        } else {
            const cData = [{
                date: value.departure_date,
                bookingtruck_date_id: value.bookingtruck_date_id,
                truckLabel: value.bookingtruck_no,
                positions: value?.positions || '0',
            }];
            setColoadData(cData)
            setLocalFormData({
                ...localFormData,
                bookingtruck_id: value.bookingtruck_id,
                bookingtruck_date_id: value.bookingtruck_date_id,
                // new_schedule_data: {
                //     ...localFormData.new_schedule_data,
                //     bookingtruck_no: value.bookingtruck_no,
                //     bookingtruck_date_id: value.bookingtruck_date_id,
                //     departure_date: value.departure_date,
                //     departure_time: value.departure_time,
                // },
                // m 11.11.25
                coload: [{
                    date: value.departure_date,
                    bookingtruck_date_id: value.bookingtruck_date_id,
                    bookingtruck_no: value.bookingtruck_no,
                    positions: value?.positions || '0',
                }],
                departure_date_time: value.departure_date_time,
                arrival_date_time: value.arrival_date_time,
                board_point: value.board_point,
                off_point: value.off_point,
                // truck_no: value.bookingtruck_no,

            });
        }

        // Initialize first co-load row when a booking truck is selected
        // if (inputGroups.length === 0) {
        //     setInputGroups([
        //         {
        //             date: value.departure_date,
        //             bookingtruck_date_id: value.bookingtruck_date_id,
        //             truckLabel: value.bookingtruck_no,
        //             positions: value?.positions || '0',
        //             isEditable: false,
        //         },
        //     ]);
        // } else {
        //     setInputGroups((prevGroups) =>
        //         prevGroups.map((group, i) =>
        //             i === 0
        //                 ? {
        //                     ...group,
        //                     date: value.departure_date,
        //                     bookingtruck_date_id: value.bookingtruck_date_id,
        //                     truckLabel: value.bookingtruck_no,
        //                     positions: value?.positions || '0',
        //                 }
        //                 : group
        //         )
        //     );
        // }

    }
    const daysClick = (day, type) => {
        const selectedDays = localFormData.new_schedule_data?.selected_days || [];
        if (selected.includes(day)) {
            setSelected(selected.filter((d) => d !== day));
        } else {
            setSelected([...selected, day]);
        }

        const updatedSelectedDays = selectedDays.includes(day)
            ? selectedDays.filter(item => item !== day)
            : [...selectedDays, day];

        setLocalFormData({
            ...localFormData,
            new_schedule_data: {
                ...localFormData.new_schedule_data,
                selected_days: updatedSelectedDays
            }
        });

    }
    const handleExtraTruckSpecChange = (e) => {
        const { value, checked } = e.target;
        setLocalFormData(prevFormData => {
            let updatedSpecifications = [...(prevFormData.extra_truck_specification || [])];
            if (checked) {
                updatedSpecifications.push(value); // Add selected option
            } else {
                updatedSpecifications = updatedSpecifications.filter(spec => spec !== value); // Remove unselected option
            }
            return {
                ...prevFormData,
                extra_truck_specification: updatedSpecifications,
            };
        });
    }
    const handleRadioChange = (event) => {
        setLocalFormData({ ...localFormData, rateType: event.target.value });
        if (event.target.value == "FR") {
            reloadRates();
        }
        if (event.target.value == "FM") {
            reloadtruckerList();
        }
    }
    const handleFixedRateChange = (id) => {
        setLocalFormData({
            ...localFormData,
            carriers: [id]
        })
        // let updatedData = [];
        // rateChart.forEach(element => {
        //     if (event.target.value == element.trucking_id) {
        //         updatedData = {
        //             ...localFormData,
        //             // 'rateId': element.id,
        //             // 'boardpoint': element.boardpoint,
        //             // 'truck_load': element.truck_load,
        //             // 'temperature': element.temperature,
        //             // 'drivers': element.drivers,
        //             // 'price': element.price,
        //             carriers: [element.trucking_id]
        //         };
        //     } else {
        //         updatedData = localFormData
        //     }
        // });
        // setLocalFormData(updatedData);
    }
    const reloadRates = async () => {
        const payload = {
            board_point: localFormData?.board_point,
            off_point: localFormData?.off_point,
            // viapoints: localFormData?.,
            // trucker_id: localFormData?.,
            driver_number: localFormData?.driver_number,
            temperature_control: localFormData?.temperature_control,
            adr: localFormData?.adr,
            rollerbed: localFormData?.rollerbed,
            // weight: localFormData?.,
            truck_height: localFormData?.truck_height,
            service_type: localFormData?.service_type,
        }
        try {
            const res = await withRFSToken.post(TRUCKERRATELIST, payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setRateChart(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const reloadtruckerList = async () => {
        try {
            const res = await withRFSToken.post(TRUCKERGRID, { status: "Active" })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData?.map((data) => ({
                        ...data,
                        value: data.trucker_id,
                        label: data.trucker_name,
                    }));
                    setTruckerList(transformData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const fetchTruckRateList = async (alldata, pos, index) => {
        try {
            const res = await withRFSToken.post(GETSCHEDULEDTRUCKS, alldata)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (pos == 'col') {
                        setInputGroups((prevGroups) =>
                            prevGroups.map((group, i) =>
                                i === index
                                    ? { ...group, truckDrop: innerData }
                                    : group
                            )
                        );
                    } else {
                        setBookingTruckList(innerData);
                        if (localdataTD) {
                            innerData.forEach((element, index) => {
                                if (element.bookingtruck_no == localdataTD.bookingtruck_no) {
                                    bookingTruckChange(element, index);
                                    setSelectedIndex(index);
                                }
                            });

                        }
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const stationDataApi = async () => {
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData.Active ? innerData.Active?.map((data) => ({
                        ...data,
                        value: data.id,
                        label: data.station_code,
                    })) : [];
                    setBoardPoint(transformData);
                    setOffPoint(transformData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const onAddButtonClick = (autosuggestId) => {
        setShowAddStation(true);
        if (autosuggestId != 'op') {
            setValue('');
        }
    }
    const handleAddAddressClick = (addressType, i) => {
        setAddressType(addressType);
        if (addressType == 'bp' && !localFormData.new_schedule_data?.boardpoint) {
            toast.error('Please select Boardpoint');
        } else if (addressType == 'op' && !localFormData.new_schedule_data?.offpoint) {
            toast.error('Please select Offpoint');
        } else if (addressType == 'vp') {
            setVpIndex(i);
            setShowAddStationAddress(true);
        } else {
            setShowAddStationAddress(true);
        }
    }
    const handleCloseModal = () => {
        setShowAddStation(false);
        setShowAddStationAddress(false);
    }

    const handleReloadAddress = async () => {
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;
                    const transformData = innerData.Active ? innerData.Active?.map((data) => ({
                        ...data,
                        value: data.id,
                        label: data.station_code,
                    })) : [];
                    setBoardPoint(transformData)
                    setOffPoint(transformData)
                    if (addressType == 'bp') {
                        if (innerData) {
                            const station = innerData.Active.find(station => station.id === localFormData.new_schedule_data.boardpoint)
                                                       
                            setBpaddress(station.station_addresses.length ? station.station_addresses?.map(handler => ({
                                value: handler.id,
                                label: `${handler.handler_name} - ${handler.address_1}`
                            })) : []);

                            // if (station.station_addresses) {
                            //     setBpaddress(station.station_addresses);
                            // } else {
                            //     setBpaddress([]);
                            // }
                        } 
                        // else {
                        //     setBpaddress([]);
                        // }
                    } else if (addressType == 'op') {
                        if (innerData) {
                            const station = innerData.Active.find(station => station.id === localFormData.new_schedule_data.offpoint)
                            // console.log('station', station) 
                            setOffPointAddress(station.station_addresses.length ? station.station_addresses?.map(handler => ({
                                value: handler.id,
                                label: `${handler.handler_name} - ${handler.address_1}`
                            })) : []);

                            // if (station.station_addresses) {
                            //     setOffPointAddress(station.station_addresses);
                            // } else {
                            //     setOffPointAddress([]);
                            // }
                        } 
                        // else {
                        //     setOffPointAddress([]);
                        // }
                    } else if (addressType == 'vp') {
                        const station = innerData.Active.find(station => station.id === localFormData.new_schedule_data.viapoints[vpIndex].viaPoint)
                        if (station.station_addresses) {
                            setLocalFormData({
                                ...localFormData,
                                new_schedule_data: {
                                    ...localFormData.new_schedule_data,
                                    viapoints: localFormData.new_schedule_data.viapoints.map((viapoint) => ({
                                        ...viapoint,
                                        viaAddress: station ? station.station_addresses : viapoint.viaAddress,
                                        viaStations: activeInnerData,
                                    })),
                                }
                            });
                        } else {
                            // setSelectedOffpoint([]);
                        }
                    }

                    setShowAddStation(false);
                    setShowAddStationAddress(false);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // const stationAddress = suggestionsBp.find(station => getSuggestionValue(station).toLowerCase() === fetchStation.station_code.toLowerCase());
    }
     
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    }
    const handleDragOver = (e) => {
        e.preventDefault();
    }
    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    }
    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
        const updatedData = { ...localFormData, base64Files };
        setLocalFormData(updatedData);
    }
    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result });
                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    setBase64Files(filesWithBase64);
                    setLocalFormData({ ...localFormData, filesWithBase64 });
                }
            };
            reader.readAsDataURL(file);
        });
    }

    const handleMultiSelectCarrierChange = (selected) => {
        const selectedIds = selected.map(item => item.trucker_id);
        setLocalFormData((prevFormData) => ({
            ...prevFormData,
            carriers: selectedIds
        }));
    }
    const [inputGroups, setInputGroups] = useState([]); // Dynamic rows
    const [truckOptions, setTruckOptions] = useState([]) // Options for "Truck No."

    const handleAddGroup = () => {
        const totalPositions = inputGroups.reduce((total, group) => total + parseInt(group.positions || 0, 10), 0);
        console.log("🚀  handleAddGroup  totalPositions:", totalPositions)
        // Prevent adding co-loads until a booking truck is selected
        if (!localFormData.bookingtruck_date_id) {
            return;
        }

        if (totalPositions < 4) {
            setLocalFormData({
                ...localFormData,
                service_type: 'L',
                service_type_value: totalPositions
            });
        } else {
            setLocalFormData({
                ...localFormData,
                service_type: 'F'
            });
        }
        if (inputGroups.length === 0) {
            console.log('coloadData', coloadData);

            setInputGroups([...coloadData, { date: '', bookingtruck_date_id: '', positions: '0', isEditable: true }]);
        }
        else if (inputGroups.length < 4) {
            if (totalPositions < 4) {
                // Subsequent clicks: Add only empty rows
                setInputGroups([...inputGroups, { date: '', bookingtruck_date_id: '', positions: '0', isEditable: true }]);
            } else {
                toast.warning('Maximum Position is already taken')
            }
        }
    }

    const handleInputChangeone = (index, field, value) => {
        // console.log("🚀 ~ handleInputChangeone ~ value:", value)
        // const updatedGroups = [...inputGroups];
        // updatedGroups[index][field] = value;

        // // Update truck options based on selected date
        // if (field === 'date' && index === inputGroups.length - 1) {
        //     const trucksForDate = getTruckOptionsForDate(value); // Replace with your actual logic
        //     setTruckOptions(trucksForDate);
        // }

        // setInputGroups(updatedGroups);
        if (field == 'date') {
            fetchTruckRateList({ 'date': value }, 'col', index);
            setInputGroups((prevGroups) =>
                prevGroups.map((group, i) =>
                    i === index // i !== 0 &&  // Skip the first row (i !== 0) and update only the matching row
                        ? { ...group, [field]: value }
                        : group
                )
            );
        }
        setInputGroups((prevGroups) => {
            // Calculate the current total positions excluding the row being updated
            const currentTotal = prevGroups.reduce((total, group, i) => {
                if (i !== index) {
                    return total + parseInt(group.positions || 0, 10);
                }
                return total;
            }, 0);

            // Calculate the new total if the change is applied
            const newTotal = currentTotal + (field === "positions" ? parseInt(value || 0, 10) : parseInt(prevGroups[index].positions || 0, 10));
            if (newTotal < 4) {
                setLocalFormData({
                    ...localFormData,
                    service_type: 'L',
                    service_type_value: newTotal
                });
            } else {
                setLocalFormData({
                    ...localFormData,
                    service_type: 'F'
                });
            }


            // Prevent the update if the new total exceeds 4
            if (newTotal > 4 && field === "positions") {
                toast.warning("Total positions cannot exceed 4.");
                return prevGroups; // Return the previous state without changes
            }

            // Apply the update for the matching row
            return prevGroups.map((group, i) =>
                i === index
                    ? { ...group, [field]: value }
                    : group
            );
        });

        // setInputGroups((prevGroups) =>
        //     prevGroups.map((group, i) =>
        //         i === index // i !== 0 &&  // Skip the first row (i !== 0) and update only the matching row
        //             ? { ...group, [field]: value }
        //             : group
        //     )
        // );
    };

    const handleDeleteGroup = (index) => {
        // Remove the group at the specified index
        const updatedGroups = inputGroups.length === 2 ? [] : inputGroups.filter((_, i) => i !== index);
        console.log('updatedGroups', updatedGroups)
        setInputGroups(updatedGroups);

        if (updatedGroups.length === 0) {
            const { coload, ...rest } = formData;
            setLocalFormData({
                ...localFormData,
                rest
            });
        }
        const totalPositions = updatedGroups.reduce((total, group) => total + parseInt(group.positions || 0, 10), 0);
        if (totalPositions < 4) {
            setLocalFormData({
                ...localFormData,
                service_type: 'L',
                service_type_value: totalPositions
            });
        } else {
            setLocalFormData({
                ...localFormData,
                service_type: 'F'
            });
        }
    };

    const getTruckOptionsForDate = (date) => {
        // Mock logic for fetching truck options based on the date
        if (date === '2025-01-01') return ['TRUCK001', 'TRUCK002'];
        if (date === '2025-01-02') return ['TRUCK003', 'TRUCK004'];
        return [];
    };

    const [formGroups, setFormGroups] = useState([]);
    const [offviaPoint, setOffviaPoint] = useState([]); // Options for via point
    const [offviaPointAddress, setOffviaPointAddress] = useState([]); // Options for via point address

    // Add a new group
    const handleAddViaClick = () => {
        // Create a new form group with an id and the viaPoint & viaPointAddress fields
        if (localFormData.new_schedule_data.viapoints.length < 4) {
            const newFormGroup = {
                id: Date.now(),  // Add a unique ID
                viaPoint: null,
                viaPointAddress: null
            };

            // Update the formGroups state with the new form group
            setFormGroups(prevFormGroups => [
                ...prevFormGroups,
                newFormGroup
            ]);

            // Update the viapoints array in localFormData (without id field)
            setLocalFormData(prevData => ({
                ...prevData,
                new_schedule_data: {
                    ...prevData.new_schedule_data,
                    viapoints: [
                        ...prevData.new_schedule_data.viapoints,
                        { viaStations: boardPoint, viaAddress: [], viaPoint: null, viaPointAddress: null }  // Only the relevant fields (no id) 
                    ]
                }
            }));
        } else {
            toast.warning('Reached Maximum Via Points')
        }

    };


    // Remove a group
    const handleDeleteviaGroup = (id) => {
        // Delete the form group from formGroups
        setFormGroups(prevFormGroups => prevFormGroups.filter(group => group.id !== id));

        // Delete the corresponding viapoint from localFormData
        setLocalFormData(prevData => ({
            ...prevData,
            new_schedule_data: {
                ...prevData.new_schedule_data,
                viapoints: prevData.new_schedule_data.viapoints.filter((_, index) => index !== id)
            }
        }));
    };


    // Update group state
    const handleGroupChange = (index, field, value) => {
        setLocalFormData((prevState) => {
            const updatedViaPoints = [...prevState.new_schedule_data.viapoints];
            updatedViaPoints[index] = {
                ...updatedViaPoints[index],
                [field]: value.value,
                [`${field}_name`]: value.label,
                viaAddress: value.address
            };

            return {
                ...prevState,
                new_schedule_data: {
                    ...prevState.new_schedule_data,
                    viapoints: updatedViaPoints,

                },
            };
        });
        // setFormGroups(
        //     formGroups.map(group =>
        //         group.id === id ? { ...group, [field]: value } : group
        //     )
        // );
    };

    //   const handletruckloadchange = 
    // console.log('local Form Data before useEffect ', localFormData)
    // useEffect(() => {
    //     { console.log('localFormDate inside useEffect', localFormData) }
    // }, [localFormData])
    const [formData, setFormData] = useState(
        [
            {
                id: '1',
                airway_bill: '',
                pieces: '',
                weight: '',
                volume: '',
                shc: '',
                commodity: '',
                flight_code: '',
                flight_number: '',
                flight_date: '',
                origin: '',
                destination: ''
            }
        ]
    );

    const handleULDInputChange = (uldInfoId, fieldName, value) => {
        if (fieldName === 'airway_bill') {
            value = handleChange(value);
        }
        setFormData(prevFormData => prevFormData.map(entry => {
            if (entry.id === uldInfoId) {
                return { ...entry, [fieldName]: value };
            }
            return entry;
        }));
    };

    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    useEffect(() => {
        // Call the fetchData function to fetch data from the API
        if (isMounted.current) return;
        fetchSHC();
        fetchDestination();
        fetchOwnerCode();
        isMounted.current = true;
    }, []);
    const fetchSHC = async () => {
        try {

            const res = await withRFSToken.post(GETSHC, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.code,
                        label: item.code,
                    })) : [];
                    setGetShc(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const removeULDStack = (uldInfoId) => {
        setFormData(prevFormData => prevFormData.filter(entry => entry.id !== uldInfoId));
    };
    const addULDStack = () => {
        const lastId = formData.length > 0 ? parseInt(formData[formData.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => [
            ...prevFormData,
            {
                id: newId,
                airway_bill: '',
                pieces: '',
                weight: '',
                volume: '',
                shc: [],
                flight_code: '',
                flight_number: '',
                flight_date: '',
                origin: '',
                destination: ''
            }
        ]);
    };
    //filter code for table
    const [boardpointFilter, setBoardpointFilter] = useState('');
    const [offpointFilter, setOffpointFilter] = useState('');

    const filteredList = bookingTruckList?.filter(item =>
        item.board_point.toLowerCase().includes(boardpointFilter.toLowerCase()) &&
        item.off_point.toLowerCase().includes(offpointFilter.toLowerCase())
    );
    return (
        <div className="">
            {console.log('localFormData ==>', localFormData)}
            {/* {console.log('offPointAddress ==>', offPointAddress)} */}
            {/* {console.log('localFormData 0=0=0>', localFormData.new_schedule_data.viapoints[vpIndex].viaPoint)} */}
            <Header logo_url='/TruckOrder' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        {isLoading ? <><div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div></> : ''}
                        <Link to={'/TruckOrder'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        <div className='main_truck'>
                            <div className='mb-3 mt-3 nestedtabs rounded'>

                                <Stepper activeStep={activeStep} className="tracorder_step">
                                    {steps.map(({ label }, index) => (
                                        <Step key={index} disabled={index !== activeStep} className="">
                                            <StepLabel onClick={() => handleStepClick(index)}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                            <div className="">
                                {finishStep ? (
                                    <div className='w-100 d-flex justify-content-center align-items-center'>
                                        <div className='complt'>
                                            <img src={Completed} alt='' />
                                            <h3>Thank you!</h3>
                                            <p>Submit was successful</p>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {showAddStationAddress &&
                                            <>
                                                <AddStationAddress
                                                    stationId={addressType == 'bp' ? localFormData.new_schedule_data?.boardpoint : (addressType == 'op' ? localFormData.new_schedule_data?.offpoint : localFormData.new_schedule_data.viapoints[vpIndex].viaPoint)}
                                                    onClose={handleCloseModal}
                                                    reloadAddress={handleReloadAddress}
                                                />
                                            </>
                                        }
                                        {showAddStation && <AddStation onClose={handleCloseModal} />}
                                        <div className="">
                                            {activeStep === 0 &&
                                                <>
                                                    <Form.Group as={Row}>
                                                        <Col sm="6">

                                                            {/* <div className='missing_info order_item min_hight_400'>  */}
                                                            <div className='missing_info order_item h-100'>
                                                                <h4 onClick={console.log(localFormData)}>Truck Type</h4>
                                                                <p>Select a booking or ad-hoc truck</p>
                                                                <div className='charter_from'>
                                                                    <Form>
                                                                        <div className='sl_status'>
                                                                            <Form.Check
                                                                                inline
                                                                                label="Booking Truck"
                                                                                name="type_of_truck"
                                                                                type='radio'
                                                                                id='booking_truck'
                                                                                value="B"
                                                                                disabled={isEdit}
                                                                                checked={localFormData.type_of_truck === 'B'}
                                                                                onChange={handleInputChange}
                                                                                onClick={() => {
                                                                                    console.log("booking truck selected")
                                                                                }}
                                                                            />

                                                                            <Form.Check
                                                                                inline
                                                                                label="Ad Hoc"
                                                                                name="type_of_truck"
                                                                                type='radio'
                                                                                id='ad-hoc'
                                                                                value="A"
                                                                                disabled={isEdit}
                                                                                checked={localFormData.type_of_truck === 'A'}
                                                                                onChange={handleInputChange}
                                                                                onClick={() => {
                                                                                    console.log("ad hoc selected");
                                                                                }}
                                                                            />

                                                                        </div>
                                                                        {localFormData.type_of_truck == 'B' && (
                                                                            <>
                                                                                <Form.Group as={Row}>
                                                                                    <Form.Label>Select Date</Form.Label>
                                                                                    <Col sm="6">
                                                                                        <Form.Control type="date" name='existing_date' value={localFormData.existing_date} disabled={isEdit} onChange={handleInputChange} />
                                                                                    </Col>
                                                                                </Form.Group>
                                                                                <Form.Group as={Row}>
                                                                                    <Col sm="12">
                                                                                        <Form.Label>List of Bookingtruck</Form.Label>
                                                                                        <div className='truck_ord_height'>
                                                                                            <Table bordered hover className='order_table'>
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th> </th>
                                                                                                        <th>Bookingtruck No</th>
                                                                                                        <th>Date</th>

                                                                                                        {/* Boardpoint header + filter */}
                                                                                                        <th>

                                                                                                            <span>Boardpoint</span>
                                                                                                            <Form.Control
                                                                                                                size="sm"
                                                                                                                type="text"
                                                                                                                placeholder="Filter..."
                                                                                                                value={boardpointFilter}
                                                                                                                onChange={(e) => setBoardpointFilter(e.target.value)}
                                                                                                            />

                                                                                                        </th>

                                                                                                        {/* Offpoint header + filter */}
                                                                                                        <th>

                                                                                                            <span>Offpoint</span>
                                                                                                            <Form.Control
                                                                                                                size="sm"
                                                                                                                type="text"
                                                                                                                placeholder="Filter..."
                                                                                                                value={offpointFilter}
                                                                                                                onChange={(e) => setOffpointFilter(e.target.value)}
                                                                                                            />

                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </thead>

                                                                                                <tbody>
                                                                                                    {filteredList?.map((value, index) => (
                                                                                                        <tr
                                                                                                            key={index}
                                                                                                            onClick={() => {
                                                                                                                bookingTruckChange(value, index);
                                                                                                                setSelectedIndex(index);
                                                                                                            }}
                                                                                                            className={index === selectedIndex ? 'selected-row' : ''}
                                                                                                        >
                                                                                                            <td>{index === selectedIndex ? <FontAwesomeIcon icon={faCircleCheck} /> : ' '}</td>
                                                                                                            <td>{value.bookingtruck_no}</td>
                                                                                                            <td>{value.departure_date} {value.departure_date_time.split('T')[0]} {value.departure_date_time.split('T')[1]}</td>
                                                                                                            <td>{value.board_point}</td>
                                                                                                            <td>{value.off_point}</td>
                                                                                                        </tr>
                                                                                                    ))}
                                                                                                </tbody>
                                                                                            </Table>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Form.Group>
                                                                            </>
                                                                        )}
                                                                        {localFormData.type_of_truck === 'A' && (
                                                                            <>
                                                                                {/* <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                                                                    <Form.Label>Bookingtruck No</Form.Label>
                                                                                    <Form.Control type="email" placeholder="#12134567" name='new_schedule_data.bookingtruck_no' value={localFormData.new_schedule_data?.bookingtruck_no} onChange={handleInputChange} />
                                                                                </Form.Group> */}
                                                                                {/* <div className='sl_status'>
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label="Export"
                                                                                        name="new_schedule_data.booking_type"
                                                                                        type='radio'
                                                                                        id='export'
                                                                                        value='E'
                                                                                        checked={localFormData.new_schedule_data?.booking_type === 'E'}
                                                                                        onChange={handleInputChange}
                                                                                    />
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label="Import"
                                                                                        value="I"
                                                                                        name="new_schedule_data.booking_type"
                                                                                        type='radio'
                                                                                        id='import'
                                                                                        checked={localFormData.new_schedule_data?.booking_type === 'I'}
                                                                                        onChange={handleInputChange}
                                                                                    />
                                                                                </div> */}
                                                                                <Form.Group as={Row} className='mb-2'>
                                                                                    <Col sm="6">
                                                                                        <Form.Label>Boardpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("bp")}> + Add </Button></Form.Label>
                                                                                        <div className='autosugg'>
                                                                                            <Select
                                                                                                options={boardPoint}
                                                                                                onChange={(selected) => {
                                                                                                    const selectedpoint = boardPoint.find(option => option.value === selected.value);
                                                                                                    // setLocalFormData({
                                                                                                    //     ...localFormData,
                                                                                                    //     new_schedule_data: {
                                                                                                    //         ...localFormData.new_schedule_data,
                                                                                                    //         boardpoint: selected.value
                                                                                                    //     },
                                                                                                    //     boardpoint_name: selected.station_code,
                                                                                                    //     boardpoint_address: ''
                                                                                                    // });
                                                                                                    if (selectedpoint.station_addresses.length === 1) {
                                                                                                        const transformData = { value: selectedpoint.station_addresses[0].id, label: `${selectedpoint.station_addresses[0].handler_name} - ${selectedpoint.station_addresses[0].address_1}` }
                                                                                                        // setSelectedOriginHandler(transformData)
                                                                                                        setBpaddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                                                                                                            value: handler.id,
                                                                                                            label: `${handler.handler_name} - ${handler.address_1}`
                                                                                                        })) : []);
                                                                                                        setLocalFormData({
                                                                                                            ...localFormData,
                                                                                                            new_schedule_data: {
                                                                                                                ...localFormData.new_schedule_data,
                                                                                                                boardpoint: selected.value,
                                                                                                                boardpoint_address: transformData.value
                                                                                                            },
                                                                                                            board_point: selected.station_code,
                                                                                                            boardpoint_address_name: transformData.label
                                                                                                        });
                                                                                                    } else {
                                                                                                        setLocalFormData({
                                                                                                            ...localFormData,
                                                                                                            new_schedule_data: {
                                                                                                                ...localFormData.new_schedule_data,
                                                                                                                boardpoint: selected.value
                                                                                                            },
                                                                                                            board_point: selected.station_code,
                                                                                                            boardpoint_address: ''
                                                                                                        });
                                                                                                        setBpaddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                                                                                                            value: handler.id,
                                                                                                            label: `${handler.handler_name} - ${handler.address_1}`
                                                                                                        })) : []);
                                                                                                    }

                                                                                                }}
                                                                                                placeholder="Boardpoint"
                                                                                                className='rfs_autoslct'
                                                                                                name="boardpoint"
                                                                                                value={boardPoint.find(option => option.id === localFormData.new_schedule_data?.boardpoint)}
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="5" className='pe-0'>
                                                                                        <Form.Label>Boardpoint Address {localFormData.board_point && <Button className='raad_adrss' onClick={() => handleAddAddressClick('bp')}>+ Add</Button>}</Form.Label> {/* > */}
                                                                                        <Select
                                                                                            options={bpaddress}
                                                                                            onChange={(selected) => {
                                                                                                setLocalFormData({
                                                                                                    ...localFormData,
                                                                                                    new_schedule_data: {
                                                                                                        ...localFormData.new_schedule_data,
                                                                                                        boardpoint_address: selected.value
                                                                                                    },
                                                                                                    boardpoint_address_name: selected.label
                                                                                                });
                                                                                            }}
                                                                                            placeholder="Address"
                                                                                            className='rfs_autoslct'
                                                                                            name="new_schedule_data.boardpoint_address"
                                                                                            isDisabled={bpaddress?.length > 0 ? false : true}
                                                                                            value={bpaddress?.length > 0 && localFormData.new_schedule_data?.boardpoint_address !== ''
                                                                                                ? bpaddress?.find(option => option.value === localFormData.new_schedule_data?.boardpoint_address)
                                                                                                : null}
                                                                                        />
                                                                                    </Col>
                                                                                </Form.Group>

                                                                                <Form.Group as={Row} className="mb-2">
                                                                                    <Col sm="6">
                                                                                        <Form.Label>Offpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("op")}> + Add </Button></Form.Label>
                                                                                        <div className='autosugg'>
                                                                                            <Select
                                                                                                options={offPoint}
                                                                                                onChange={(selected) => {
                                                                                                    const selectedpoint = boardPoint.find(option => option.value === selected.value);
                                                                                                    // setOffPointAddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                                                                                                    //     value: handler.id,
                                                                                                    //     label: `${handler.handler_name} - ${handler.address_1}`
                                                                                                    // })) : []);
                                                                                                    // setLocalFormData({
                                                                                                    //     ...localFormData,
                                                                                                    //     new_schedule_data: {
                                                                                                    //         ...localFormData.new_schedule_data,
                                                                                                    //         offpoint: selected.value
                                                                                                    //     },
                                                                                                    //     offpoint_name: selected.station_code,
                                                                                                    //     offpoint_address: ''
                                                                                                    // });

                                                                                                    if (selectedpoint.station_addresses.length === 1) {
                                                                                                        const transformData = { value: selectedpoint.station_addresses[0].id, label: `${selectedpoint.station_addresses[0].handler_name} - ${selectedpoint.station_addresses[0].address_1}` }
                                                                                                        // setSelectedOriginHandler(transformData)
                                                                                                        setOffPointAddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                                                                                                            value: handler.id,
                                                                                                            label: `${handler.handler_name} - ${handler.address_1}`
                                                                                                        })) : []);
                                                                                                        setLocalFormData({
                                                                                                            ...localFormData,
                                                                                                            new_schedule_data: {
                                                                                                                ...localFormData.new_schedule_data,
                                                                                                                offpoint: selected.value,
                                                                                                                offpoint_address: transformData.value
                                                                                                            },
                                                                                                            off_point: selected.station_code,
                                                                                                            offpoint_address_name: transformData.label
                                                                                                        });
                                                                                                    } else {
                                                                                                        setLocalFormData({
                                                                                                            ...localFormData,
                                                                                                            new_schedule_data: {
                                                                                                                ...localFormData.new_schedule_data,
                                                                                                                offpoint: selected.value
                                                                                                            },
                                                                                                            off_point: selected.station_code,
                                                                                                            offpoint_address: ''
                                                                                                        });
                                                                                                        setOffPointAddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                                                                                                            value: handler.id,
                                                                                                            label: `${handler.handler_name} - ${handler.address_1}`
                                                                                                        })) : []);
                                                                                                    }
                                                                                                }}
                                                                                                placeholder="Offpoint"
                                                                                                className='rfs_autoslct'
                                                                                                name="new_schedule_data.offpoint"
                                                                                                value={offPoint.find(option => option.value === localFormData.new_schedule_data?.offpoint)}
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="5" className='pe-0'>
                                                                                        <Form.Label>Offpoint Address {localFormData.off_point && <Button className='raad_adrss' onClick={() => handleAddAddressClick('op')}>+ Add</Button>}</Form.Label> {/* > */}
                                                                                        <Select
                                                                                            options={offPointAddress}
                                                                                            onChange={(selected) => {
                                                                                                setLocalFormData({
                                                                                                    ...localFormData,
                                                                                                    new_schedule_data: {
                                                                                                        ...localFormData.new_schedule_data,
                                                                                                        offpoint_address: selected.value
                                                                                                    },
                                                                                                    offpoint_address_name: selected.label
                                                                                                });
                                                                                            }}
                                                                                            placeholder="Address"
                                                                                            className='rfs_autoslct'
                                                                                            name="new_schedule_data.offpoint_address"
                                                                                            isDisabled={offPointAddress.length > 0 ? false : true}
                                                                                            value={offPointAddress.length > 0 && localFormData.new_schedule_data?.offpoint_address !== ''
                                                                                                ? offPointAddress.find(option => option.value === localFormData.new_schedule_data?.offpoint_address)
                                                                                                : null}
                                                                                        />
                                                                                    </Col>
                                                                                </Form.Group>


                                                                                {/* <hr /> */}

                                                                                {/* <Form.Group className="mb-2 sl_status" controlId="exampleForm.ControlInput1">
                                                                                        <Form.Check
                                                                                            inline
                                                                                            label="One-Off"
                                                                                            name="new_schedule_data.trip_type"
                                                                                            type='radio'
                                                                                            id='one-off'
                                                                                            value="O"
                                                                                            checked={localFormData.new_schedule_data?.trip_type === 'O'}
                                                                                            onChange={handleInputChange}
                                                                                        />
                                                                                        <Form.Check
                                                                                            inline
                                                                                            label="Frequent"
                                                                                            name="new_schedule_data.trip_type"
                                                                                            type='radio'
                                                                                            id='Frequent'
                                                                                            value="F"
                                                                                            checked={localFormData.new_schedule_data?.trip_type === 'F'}
                                                                                            onChange={handleInputChange}
                                                                                        />
                                                                                    </Form.Group> */}
                                                                                {localFormData.new_schedule_data?.trip_type === 'O' && (
                                                                                    <>
                                                                                        {/* <Form.Group as={Row} className='mb-2'>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Departure Date</Form.Label>
                                                                                                <Form.Control type="date" name='new_schedule_data.departure_date' value={localFormData.new_schedule_data?.departure_date} onChange={handleInputChange} />
                                                                                            </Col>
                                                                                        </Form.Group>
                                                                                        <Form.Group as={Row}>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Departure Time</Form.Label>
                                                                                                <Form.Control type="time" name='new_schedule_data.departure_time' value={localFormData.new_schedule_data?.departure_time} onChange={handleInputChange} />
                                                                                            </Col>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Est. Travel Time</Form.Label>
                                                                                                <Form.Control type="time" name='new_schedule_data.travel_time' value={localFormData.new_schedule_data?.travel_time} onChange={handleInputChange} />
                                                                                            </Col>
                                                                                        </Form.Group> */}

                                                                                        {/* <Form.Group as={Row} className='mb-2'>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Departure Date / Time</Form.Label>
                                                                                                <Form.Control
                                                                                                    type="datetime-local"
                                                                                                    name='new_schedule_data.departure_datetime'
                                                                                                    value={localFormData.new_schedule_data?.departure_datetime}
                                                                                                    onChange={handleInputChange}
                                                                                                />
                                                                                            </Col>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Arrival Date / Time</Form.Label>
                                                                                                <Form.Control
                                                                                                    type="datetime-local"
                                                                                                    name='new_schedule_data.arrival_datetime'
                                                                                                    value={localFormData.new_schedule_data?.arrival_datetime}
                                                                                                    onChange={handleInputChange}
                                                                                                />
                                                                                            </Col>
                                                                                        </Form.Group>
                                                                                        <Form.Group as={Row}>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Travel Days</Form.Label>
                                                                                                <Form.Control
                                                                                                    type="number"
                                                                                                    min={0}
                                                                                                    name='new_schedule_data.travel_days'
                                                                                                    value={localFormData.new_schedule_data?.travel_days}
                                                                                                    onChange={handleInputChange}
                                                                                                />
                                                                                            </Col>
                                                                                        </Form.Group> */}
                                                                                    </>
                                                                                )}
                                                                                {localFormData.new_schedule_data?.trip_type === 'F' && (
                                                                                    <>
                                                                                        <Form.Label>Select Weekdays</Form.Label>

                                                                                        <ul className='freq_week mb-3'>
                                                                                            <li className={selected.includes(0) ? 'selected' : ''} onClick={() => daysClick(0)}>Su</li>
                                                                                            <li className={selected.includes(1) ? 'selected' : ''} onClick={() => daysClick(1)}>Mo</li>
                                                                                            <li className={selected.includes(2) ? 'selected' : ''} onClick={() => daysClick(2)}>Tu</li>
                                                                                            <li className={selected.includes(3) ? 'selected' : ''} onClick={() => daysClick(3)}>We</li>
                                                                                            <li className={selected.includes(4) ? 'selected' : ''} onClick={() => daysClick(4)}>Th</li>
                                                                                            <li className={selected.includes(5) ? 'selected' : ''} onClick={() => daysClick(5)}>Fr</li>
                                                                                            <li className={selected.includes(6) ? 'selected' : ''} onClick={() => daysClick(6)}>Sa</li>
                                                                                        </ul>

                                                                                        <Form.Group as={Row} className='mb-2'>
                                                                                            <Form.Label>Bookingtruck Start & End Date </Form.Label>
                                                                                            <Col sm="6">
                                                                                                <Form.Control type="date" name='new_schedule_data.start_date' value={localFormData.new_schedule_data?.start_date} onChange={handleInputChange} />
                                                                                            </Col>

                                                                                            <Col sm="6">
                                                                                                <Form.Control type="date" name='new_schedule_data.end_date' value={localFormData.new_schedule_data?.end_date} onChange={handleInputChange} />
                                                                                            </Col>
                                                                                        </Form.Group>

                                                                                        <Form.Group as={Row} className='mb-2'>

                                                                                            <Col sm="6">
                                                                                                <Form.Label>Departure Time</Form.Label>
                                                                                                <Form.Control type="time" name='new_schedule_data.departure_time' value={localFormData.new_schedule_data?.departure_time} onChange={handleInputChange} />
                                                                                            </Col>
                                                                                            <Col sm="6">
                                                                                                <Form.Label>Est. Travel Time</Form.Label>
                                                                                                <Form.Control type="time" name='new_schedule_data.travel_time' value={localFormData.new_schedule_data?.travel_time} onChange={handleInputChange} />
                                                                                            </Col>
                                                                                        </Form.Group>
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </Form>
                                                                </div>
                                                            </div>
                                                            {/* coload was here  */}

                                                        </Col>

                                                        <Col sm="6">
                                                            <div className='missing_info order_item h-100'>
                                                                <h4>Truck Information</h4>
                                                                <p>Indicate truck specifications required</p>
                                                                <div className='charter_from'>

                                                                    <Form.Group className='mb-2'>
                                                                        <Form.Label>Operational Truck <span>*</span></Form.Label>
                                                                        <Form.Control
                                                                            name='truck_no'
                                                                            value={localFormData.truck_no}
                                                                            onChange={handleInputChange}
                                                                            placeholder='Truck Number'
                                                                        />
                                                                    </Form.Group>
                                                                    {/* <Form.Group as={Row} className='mb-2'>
                                                                        <Form.Label>Date and Time <span>*</span></Form.Label>
                                                                        <Col sm="6">
                                                                            <Form.Control
                                                                                name='new_schedule_data.departure_date'
                                                                                type='date'
                                                                                value={localFormData.departure_date}
                                                                                // disabled={selectedIndex !== null}
                                                                                onChange={handleInputChange}
                                                                                placeholder='Date'
                                                                            />
                                                                        </Col>
                                                                        <Col sm="6">
                                                                            <Form.Control
                                                                                name='new_schedule_data.departure_time'
                                                                                type='time'
                                                                                value={localFormData.departure_time}
                                                                                // disabled={selectedIndex !== null}
                                                                                onChange={handleInputChange}
                                                                                placeholder='Time'
                                                                            />
                                                                        </Col>
                                                                    </Form.Group> */}
                                                                    <Form.Group as={Row} className='mb-2'>
                                                                        <Col sm="6">
                                                                            <Form.Label>Departure Date / Time</Form.Label>
                                                                            <Form.Control type="datetime-local" name='departure_date_time' value={localFormData.departure_date_time} onChange={handleInputChange} />
                                                                        </Col>
                                                                        <Col sm="6">
                                                                            <Form.Label>Arrival Date / Time</Form.Label>
                                                                            <Form.Control type="datetime-local" name='arrival_date_time' value={localFormData.arrival_date_time} onChange={handleInputChange} />
                                                                        </Col>
                                                                    </Form.Group>
                                                                    <Form.Group as={Row}>
                                                                        <Form.Label>Truck Load <span>*</span></Form.Label>
                                                                        <div className='d-flex sl_status'>

                                                                            <Form.Check
                                                                                inline
                                                                                label="FTL"
                                                                                name="service_type"
                                                                                type='radio'
                                                                                id='ftl'
                                                                                value="F"
                                                                                disabled={inputGroups?.length > 0}
                                                                                checked={localFormData?.service_type === 'F'}
                                                                                onChange={handleInputChange}
                                                                            />

                                                                            <Form.Check
                                                                                inline
                                                                                label="LTL"
                                                                                name="service_type"
                                                                                type='radio'
                                                                                id='ltl'
                                                                                value="L"
                                                                                disabled={inputGroups?.length > 0}
                                                                                checked={localFormData?.service_type === 'L'}
                                                                                onChange={handleInputChange}
                                                                            />

                                                                            <div className='ltl_drop'>
                                                                                {localFormData?.service_type === 'L' &&
                                                                                    <Select
                                                                                        options={ltlOptoins}
                                                                                        onChange={(selected) => {
                                                                                            const updatedData = { ...localFormData, service_type_value: selected.value };
                                                                                            setLocalFormData(updatedData);
                                                                                        }}
                                                                                        placeholder="Amount of Positions"
                                                                                        className='rfs_autoslct'
                                                                                        name="service_type_value"
                                                                                        isDisabled={inputGroups?.length > 0}
                                                                                        value={ltlOptoins.find(option => option.value === String(localFormData.service_type_value))}
                                                                                    />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </Form.Group>
                                                                    <Form.Group as={Row}>
                                                                        <Col sm='6'>
                                                                            <Form.Label>Number of Drivers <span>*</span></Form.Label>
                                                                            <div className='sl_status num_drive'>
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="1"
                                                                                    name="driver_number"
                                                                                    type='radio'
                                                                                    id='1'
                                                                                    value="1"
                                                                                    checked={localFormData.driver_number == 1}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="2"
                                                                                    name="driver_number"
                                                                                    type='radio'
                                                                                    id='2'
                                                                                    value="2"
                                                                                    checked={localFormData.driver_number == 2}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                        <Col sm='6'>
                                                                            <Form.Label>ADR Required <span>*</span></Form.Label>
                                                                            <div className='sl_status'>
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="Yes"
                                                                                    name="adr"
                                                                                    type='radio'
                                                                                    id='adr1'
                                                                                    value="1"
                                                                                    checked={localFormData.adr == 1}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="No"
                                                                                    name="adr"
                                                                                    type='radio'
                                                                                    id='adr0'
                                                                                    value="0"
                                                                                    checked={localFormData.adr == 0}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Form.Group>
                                                                    <hr />
                                                                    <Form.Group as={Row}>
                                                                        <Form.Label>Temperature Control <span>*</span></Form.Label>
                                                                        <div className='sl_status'>
                                                                            <Form.Check
                                                                                inline
                                                                                label="No"
                                                                                name="temperature_control"
                                                                                type='radio'
                                                                                id='N'
                                                                                value="N"
                                                                                checked={localFormData.temperature_control === 'N'}
                                                                                onChange={handleInputChange}
                                                                            />
                                                                            <Form.Check
                                                                                inline
                                                                                label="Temperature"
                                                                                name="temperature_control"
                                                                                type='radio'
                                                                                id='TC'
                                                                                value="TC"
                                                                                checked={localFormData.temperature_control === 'TC'}
                                                                                onChange={handleInputChange}
                                                                            />
                                                                            <Form.Check
                                                                                inline
                                                                                label="Multi-Temperature "
                                                                                name="temperature_control"
                                                                                type='radio'
                                                                                id='MC'
                                                                                value="MC"
                                                                                checked={localFormData.temperature_control === 'MC'}
                                                                                onChange={handleInputChange}
                                                                            />

                                                                            {localFormData.temperature_control === 'TC' &&
                                                                                <div className='multi_temp'>
                                                                                    <h4>Temperature Range</h4>
                                                                                    <div className='d-flex'>
                                                                                        <InputGroup className="ra_temprang">
                                                                                            <Form.Control
                                                                                                type="number"
                                                                                                value={localFormData.temperature_range_one_start}
                                                                                                min={0}
                                                                                                max={18}
                                                                                                onChange={(e) => tempChange('temperature_range_one_start', e)}
                                                                                            />
                                                                                            <InputGroup.Text>°C</InputGroup.Text>
                                                                                            <div className='temprt'>
                                                                                                <div className="d-flex flex-column">
                                                                                                    <Button variant="link" onClick={() => handleIncrease('temperature_range_one_start', 18)} className="">
                                                                                                        <FontAwesomeIcon icon={faChevronUp} />
                                                                                                    </Button>
                                                                                                    <Button variant="link" onClick={() => handleDecrease('temperature_range_one_start', 0)} className="">
                                                                                                        <FontAwesomeIcon icon={faChevronDown} />
                                                                                                    </Button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </InputGroup>
                                                                                        <span className='rang_gap'>-</span>
                                                                                        <InputGroup className="ra_temprang">
                                                                                            <Form.Control
                                                                                                type="number"
                                                                                                value={localFormData.temperature_range_one_end}
                                                                                                min={localFormData.temperature_range_one_start}
                                                                                                onChange={(e) => tempChange('temperature_range_one_end', e)}
                                                                                            />
                                                                                            <InputGroup.Text>°C</InputGroup.Text>
                                                                                            <div className='temprt'>
                                                                                                <div className="d-flex flex-column">
                                                                                                    <Button variant="link" onClick={() => handleIncrease('temperature_range_one_end', 18)} className="">
                                                                                                        <FontAwesomeIcon icon={faChevronUp} />
                                                                                                    </Button>
                                                                                                    <Button variant="link" onClick={() => handleDecrease('temperature_range_one_end', localFormData.temperature_range_one_start)} className="">
                                                                                                        <FontAwesomeIcon icon={faChevronDown} />
                                                                                                    </Button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </InputGroup>
                                                                                    </div>

                                                                                </div>
                                                                            }
                                                                            {localFormData.temperature_control === 'MC' &&
                                                                                <div className='multi_temp'>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <h4>Temperature Range 1</h4>
                                                                                            <div className='d-flex'>
                                                                                                <InputGroup className="ra_temprang">
                                                                                                    <Form.Control
                                                                                                        type="number"
                                                                                                        value={localFormData.temperature_range_two_start}
                                                                                                        onChange={(e) => tempChange('temperature_range_two_start', e)}
                                                                                                    />
                                                                                                    <InputGroup.Text>°C</InputGroup.Text>
                                                                                                    <div className='temprt'>
                                                                                                        <div className="d-flex flex-column">
                                                                                                            <Button variant="link" onClick={() => handleIncrease('temperature_range_two_start', 18)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronUp} />
                                                                                                            </Button>
                                                                                                            <Button variant="link" onClick={() => handleDecrease('temperature_range_two_start', 0)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronDown} />
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </InputGroup>
                                                                                                <span className='rang_gap'>-</span>
                                                                                                <InputGroup className="ra_temprang">
                                                                                                    <Form.Control
                                                                                                        type="number"
                                                                                                        value={localFormData.temperature_range_two_end}
                                                                                                        onChange={(e) => tempChange('temperature_range_two_end', e)}
                                                                                                    />
                                                                                                    <InputGroup.Text>°C</InputGroup.Text>
                                                                                                    <div className='temprt'>
                                                                                                        <div className="d-flex flex-column">
                                                                                                            <Button variant="link" onClick={() => handleIncrease('temperature_range_two_end', 18)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronUp} />
                                                                                                            </Button>
                                                                                                            <Button variant="link" onClick={() => handleDecrease('temperature_range_two_end', localFormData.temperature_range_two_start)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronDown} />
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </InputGroup>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <h4>Temperature Range 2</h4>
                                                                                            <div className='d-flex'>
                                                                                                <InputGroup className="ra_temprang">
                                                                                                    <Form.Control
                                                                                                        type="number"
                                                                                                        value={localFormData.temperature_range_three_start}
                                                                                                        onChange={(e) => tempChange('temperature_range_three_start', e)}
                                                                                                    />
                                                                                                    <InputGroup.Text>°C</InputGroup.Text>
                                                                                                    <div className='temprt'>
                                                                                                        <div className="d-flex flex-column">
                                                                                                            <Button variant="link" onClick={() => handleIncrease('temperature_range_three_start', 18)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronUp} />
                                                                                                            </Button>
                                                                                                            <Button variant="link" onClick={() => handleDecrease('temperature_range_three_start', 0)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronDown} />
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </InputGroup>
                                                                                                <span className='rang_gap'>-</span>
                                                                                                <InputGroup className="ra_temprang">
                                                                                                    <Form.Control
                                                                                                        type="number"
                                                                                                        value={localFormData.temperature_range_three_end}
                                                                                                        onChange={(e) => tempChange('temperature_range_three_end', e)}
                                                                                                    />
                                                                                                    <InputGroup.Text>°C</InputGroup.Text>
                                                                                                    <div className='temprt'>
                                                                                                        <div className="d-flex flex-column">
                                                                                                            <Button variant="link" onClick={() => handleIncrease('temperature_range_three_end', 18)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronUp} />
                                                                                                            </Button>
                                                                                                            <Button variant="link" onClick={() => handleDecrease('temperature_range_three_end', localFormData.temperature_range_three_start)} className="">
                                                                                                                <FontAwesomeIcon icon={faChevronDown} />
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </InputGroup>
                                                                                            </div>
                                                                                        </li>

                                                                                    </ul>

                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </Form.Group>
                                                                    <hr />
                                                                    <Form.Group as={Row} className='mb-2'>
                                                                        <Form.Label>Truck Material <span>*</span></Form.Label>
                                                                        <div className="mb-2 sl_status">
                                                                            <Form.Check
                                                                                inline
                                                                                label="Hard Cover"
                                                                                name="truck_material"
                                                                                type='radio'
                                                                                id='HC'
                                                                                value="HC"
                                                                                checked={localFormData.truck_material === 'HC'}
                                                                                onChange={handleInputChange}
                                                                            />
                                                                            <Form.Check
                                                                                inline
                                                                                label="Curtain Slider"
                                                                                name="truck_material"
                                                                                type='radio'
                                                                                id='CS'
                                                                                value="CS"
                                                                                checked={localFormData.truck_material === 'CS'}
                                                                                onChange={handleInputChange}
                                                                            />
                                                                            <Form.Check
                                                                                inline
                                                                                label="Flatbed Trailer"
                                                                                name="truck_material"
                                                                                type='radio'
                                                                                id='FT'
                                                                                value="FT"
                                                                                checked={localFormData.truck_material === 'FT'}
                                                                                onChange={handleInputChange}
                                                                            />
                                                                            {localFormData.truck_material === 'CS' &&
                                                                                <div className='multi_temp'>
                                                                                    <h4>Extra Truck Option</h4>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Extra Wide Truck"
                                                                                                name="extra_truck_specification"
                                                                                                value="Extra Wide Truck"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Extra Wide Truck")}
                                                                                            />
                                                                                        </li>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Soft Top"
                                                                                                name="extra_truck_specification"
                                                                                                value="Soft Top"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Soft Top")}
                                                                                            />
                                                                                        </li>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Reinforced Curtain"
                                                                                                name="extra_truck_specification"
                                                                                                value="Reinforced Curtain"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Reinforced Curtain")}
                                                                                            />
                                                                                        </li>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Adjustable Roof"
                                                                                                name="extra_truck_specification"
                                                                                                value="Adjustable Roof"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Adjustable Roof")}
                                                                                            />
                                                                                        </li>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Exceptional Transport"
                                                                                                name="extra_truck_specification"
                                                                                                value="Exceptional Transport"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Exceptional Transport")}
                                                                                            />
                                                                                        </li>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Side Loading Capbility"
                                                                                                name="extra_truck_specification"
                                                                                                value="Side Loading Capbility"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Side Loading Capbility")}
                                                                                            />
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            }
                                                                            {localFormData.truck_material === 'FT' &&
                                                                                <div className='multi_temp'>
                                                                                    <h4>Extra Truck Option</h4>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <Form.Check
                                                                                                inline
                                                                                                label="Extendable Length"
                                                                                                name="extra_truck_specification"
                                                                                                value="Extendable Length"
                                                                                                onChange={handleExtraTruckSpecChange}
                                                                                                checked={localFormData.extra_truck_specification?.includes("Extendable Length")}
                                                                                            />
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </Form.Group>
                                                                    <Form.Group as={Row} className='mb-2'>
                                                                        <Col sm='6'>
                                                                            <Form.Label>Min. Truck Height (cm) <span>*</span></Form.Label>
                                                                            <div className="mb-2">
                                                                                <Form.Control
                                                                                    name='truck_height'
                                                                                    value={localFormData.truck_height}
                                                                                    onChange={handleInputChange}
                                                                                    placeholder='Min. Truck Height'
                                                                                    style={{ height: "32px" }}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                        <Col sm='6'>
                                                                            <Form.Label>Rollerbed <span>*</span></Form.Label>
                                                                            <div className="mb-2 sl_status">
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="Yes"
                                                                                    name="rollerbed"
                                                                                    type='radio'
                                                                                    id='yes'
                                                                                    value="Y"
                                                                                    checked={localFormData.rollerbed === 'Y'}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="No"
                                                                                    name="rollerbed"
                                                                                    type='radio'
                                                                                    id='no'
                                                                                    value="N"
                                                                                    checked={localFormData.rollerbed === 'N'}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Form.Group>
                                                                    <hr />
                                                                    <Form.Group className='mb-2'>
                                                                        <Form.Label>Remarks</Form.Label>
                                                                        <Form.Control as="textarea" rows={3} name='remarks' value={localFormData.remarks} onChange={handleInputChange} placeholder='' style={{ height: 'auto' }} />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Form.Group>

                                                </>
                                            }
                                            {activeStep === 1 && localFormData.type_of_truck === 'A' &&
                                                <>
                                                    <div className='flbg add_awb'>
                                                        <div className='d-flex justify-content-between adds_top'>
                                                            <h3>Add AWB</h3>
                                                            <span>Total AWB<Badge>{formData.length}</Badge></span>
                                                        </div>
                                                        <div className='stck_middle mt-2'>
                                                            {formData && formData.map((section, index) => {
                                                                return (
                                                                    <div className='d-flex mb-3 sub_add' key={index}>
                                                                        {/* {console.log('100', section)} */}
                                                                        <div className='saairbill'>
                                                                            <Form.Label>Airway Bill <span>*</span></Form.Label>
                                                                            <Form.Control type="text"
                                                                                name='airway_bill'
                                                                                value={section.airway_bill || ''}
                                                                                maxLength={13}
                                                                                // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                                                onChange={(e) => handleULDInputChange(section.id, 'airway_bill', e.target.value)} />
                                                                        </div>
                                                                        <div className='sapiec'>
                                                                            <Form.Label>Pieces <span>*</span></Form.Label>
                                                                            <Form.Control type="text"
                                                                                name='pieces'
                                                                                value={section.pieces || ''}
                                                                                maxLength='6' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6); }}
                                                                                onChange={(e) => handleULDInputChange(section.id, 'pieces', e.target.value)} />
                                                                        </div>
                                                                        <div className='saweight'>
                                                                            <Form.Label>Weight</Form.Label>
                                                                            <Form.Control type="text"
                                                                                name='weight'
                                                                                value={section.weight || ''}
                                                                                maxLength='5'
                                                                                placeholder='0.00'
                                                                                // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                                                // onChange={(e) => handleULDInputChange(section.id, 'weight', e.target.value)}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    const formattedValue = value.match(/^\d*\.?\d{0,2}$/) ? value : section.weight || ''; // Allow up to 2 decimal places
                                                                                    handleULDInputChange(section.id, 'weight', formattedValue);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className='savolume'>
                                                                            <Form.Label>Volume</Form.Label>
                                                                            <Form.Control type="text"
                                                                                name='volume'
                                                                                value={section.volume || ''}
                                                                                placeholder='0.00'
                                                                                // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                                                // onChange={(e) => handleULDInputChange(section.id, 'volume', e.target.value)}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    const formattedValue = value.match(/^\d*\.?\d{0,2}$/) ? value : section.volume || ''; // Allow up to 2 decimal places
                                                                                    handleULDInputChange(section.id, 'volume', formattedValue);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className='sashc'>
                                                                            <Form.Label>SHC</Form.Label>
                                                                            <MultiSelect
                                                                                options={getShc}
                                                                                value={getShc.filter(option => section.shc?.includes(option.value)) || ''}
                                                                                onChange={(selectedOptions) => {
                                                                                    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                                                    handleULDInputChange(section.id, 'shc', selectedValues);
                                                                                }}
                                                                                labelledBy="Select "
                                                                                className='multiselect autoslct'
                                                                                name="shc"
                                                                            />
                                                                        </div>
                                                                        <div className='sacommodity'>
                                                                            <Form.Label>Commodity</Form.Label>
                                                                            <Form.Control type="text"
                                                                                name='commodity'
                                                                                value={section.commodity || ''}
                                                                                // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                                                onChange={(e) => handleULDInputChange(section.id, 'commodity', e.target.value)} />
                                                                        </div>
                                                                        {/* <div className='saflight'>
                                                                            <Form.Label>Flight Number <span>*</span></Form.Label>
                                                                            <div className='d-flex align-items-center'>
                                                                                <div className='flightdrp'>
                                                                                    <Select
                                                                                        options={getOwnerCodes}
                                                                                        onChange={(e) => handleULDInputChange(section.id, 'flight_code', e.value)}
                                                                                        placeholder="Flight"
                                                                                        className='autoslct'
                                                                                        name="flight_code"
                                                                                        value={getOwnerCodes.find(option => option.value === section.flight_code) || ''}
                                                                                    />
                                                                                </div>
                                                                                <div className='space'>-</div>
                                                                                <div className='flightn'>
                                                                                    <Form.Control type="text"
                                                                                        name='flight_number'
                                                                                        value={section.flight_number || ''}
                                                                                        maxLength='8'
                                                                                        // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                        onChange={(e) => handleULDInputChange(section.id, 'flight_number', e.target.value)} />
                                                                                </div>

                                                                            </div>


                                                                        </div> */}
                                                                        {/* <div className='flight_date'>
                                                                            <Form.Group>
                                                                                <Form.Label>Flight Date <span>*</span></Form.Label>
                                                                                <Form.Control
                                                                                    type="datetime-local"
                                                                                    name='flight_date'
                                                                                    onChange={(e) => handleULDInputChange(section.id, 'flight_date', e.target.value)}
                                                                                    value={section.flight_date}
                                                                                />
                                                                            </Form.Group>
                                                                        </div> */}
                                                                        <div className='saorigin'>
                                                                            <Form.Label>Origin <span>*</span></Form.Label>
                                                                            <Select
                                                                                options={getDestination}
                                                                                onChange={(e) => handleULDInputChange(section.id, 'origin', e.value)}
                                                                                placeholder="Origin"
                                                                                className='autoslct'
                                                                                name="origin"
                                                                                value={getDestination.find(option => option.value === section.origin) || ''}
                                                                            />
                                                                        </div>
                                                                        <div className='sadesti'>
                                                                            <Form.Label>Destination <span>*</span></Form.Label>
                                                                            <Select
                                                                                options={getDestination}
                                                                                onChange={(e) => handleULDInputChange(section.id, 'destination', e.value)}
                                                                                placeholder="Destination"
                                                                                className='autoslct'
                                                                                name="destination"
                                                                                value={getDestination.find(option => option.value === section.destination) || ''}
                                                                            />
                                                                        </div>
                                                                        <div className='imag_trash'>
                                                                            {formData.length > 1 && (
                                                                                <img src={Trash} alt='' onClick={() => removeULDStack(section.id)} />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                            {<div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add AWB</Button></div>}
                                                        </div>
                                                        {/* <div className='text-center mt-5'>
                                                            <Button variant="light" className='stk_cancel' onClick={handleModalOpen}>CANCEL</Button>
                                                            <Button variant="primary" className='stk_save' onClick={handleSave}>SAVE</Button>
                                                        </div> */}
                                                    </div>
                                                </>
                                            }
                                            {activeStep === (localFormData.type_of_truck === 'A' ? 2 : 1) &&
                                                <>
                                                    <Form.Group as={Row}>
                                                        <Col sm="6">
                                                            <div className='missing_info order_item h-100'>
                                                                <div className='charter_top'>
                                                                    <h4>Truck Booking</h4>
                                                                    <p>Select a booking or ad-hoc truck</p>
                                                                </div>
                                                                <div className='charter_from'>
                                                                    <div className='sl_status'>
                                                                        <Form.Check inline label={"Fixed Rate"} type="radio" name="radioGroup" value={"FR"}
                                                                            checked={localFormData.rateType === "FR"} onChange={handleRadioChange} />
                                                                        <Form.Check inline label={"Free Market"} type="radio" name="radioGroup" value={"FM"}
                                                                            checked={localFormData.rateType === "FM"} onChange={handleRadioChange} />
                                                                    </div>

                                                                    {localFormData.rateType === 'FR' && (
                                                                        <>
                                                                            <div className="plans mt-3">
                                                                                {rateChart?.length ?
                                                                                    <>
                                                                                        {rateChart?.map((rates, index) => (
                                                                                            <>
                                                                                                <div className="truck-card">
                                                                                                    <label className="truck-header d-flex justify-content-between align-items-cente" htmlFor={"rate" + index}>
                                                                                                        {/* <div class="truck-header d-flex justify-content-between align-items-center"> */}
                                                                                                        <h6 class="mb-0">Carrier Name - {rates.trucking_company} </h6>
                                                                                                        <input
                                                                                                            type="radio" name="plan"
                                                                                                            id={"rate" + index}
                                                                                                            value={rates.trucking_id}
                                                                                                            onChange={() => handleFixedRateChange(rates.trucking_id)}
                                                                                                            checked={localFormData?.carriers[0] == rates.trucking_id}
                                                                                                        />

                                                                                                        {/* </div> */}
                                                                                                    </label>

                                                                                                    <div class="truck-details mt-2">
                                                                                                        <ul class="list-unstyled mb-0">
                                                                                                            <li><span>Fixed Rate:</span> <span>{currencyOptions?.find(opt => opt.value === rates.currency).symbol}{rates.total_cost}</span></li>
                                                                                                            <li><span>Performance Rate:</span> <span>60%</span></li>
                                                                                                            <li><span>CO2 Emission:</span> <span>CO2 Emission</span></li>
                                                                                                        </ul>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        ))}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <h4>Fixed rate is not available for this route.</h4>
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                    {/* {localFormData.rateType === 'FR' && (
                                                                        <div className="plans mt-3">
                                                                            {rateChart && rateChart?.map((rates, index) => (
                                                                                <>
                                                                                    <label className="plan basic-plan" htmlFor={"rate" + index}>
                                                                                        <input type="radio" name="plan" id={"rate" + index} value={rates.id}
                                                                                            onChange={handleFixedRateChange} />
                                                                                        <div className="plan-content">
                                                                                            <ul>
                                                                                                <li><span>Boardpoint: </span> <span>{rates.boardpoint}</span></li>
                                                                                                <li><span>Truck Load: </span> <span>{rates.truck_load}</span></li>
                                                                                                <li><span>Temperature: </span> <span>{rates.temperature}</span></li>
                                                                                                <li><span>Drivers: </span> <span>{rates.drivers}</span></li>
                                                                                                <li><span>Price: </span> <span>{rates.price}</span></li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </label>
                                                                                </>
                                                                            ))}
                                                                        </div>
                                                                    )} */}

                                                                    {localFormData.rateType === 'FM' && (
                                                                        <div className='multis'>
                                                                            <Form.Label className='mt-2'>List of Carriers</Form.Label>
                                                                            <Form.Group as={Row}>
                                                                                <Col sm="6">
                                                                                    <Form.Group controlId="dropdown">
                                                                                        <MultiSelect
                                                                                            options={truckerList}
                                                                                            value={truckerList?.filter(item => localFormData.carriers?.includes(item.trucker_id))}
                                                                                            onChange={handleMultiSelectCarrierChange}
                                                                                            labelledBy="Select "
                                                                                            className='multiselect'
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Form.Group>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* <hr /> */}

                                                                {/* <h4>Adding Documents</h4>
                                                                <p>Upload your any attachment here</p>
                                                                <div className='dropfile mt-3' onDrop={handleDrop} onDragOver={handleDragOver} >
                                                                    <h3>Drag and drop files here</h3>
                                                                    <p>Or</p>
                                                                    <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                                                    <span>Maximum file size 4 MB</span>
                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        style={{ display: 'none' }}
                                                                        onChange={handleFileChange}
                                                                        multiple
                                                                    />
                                                                </div>
                                                                <div className='uploadbox'>
                                                                    {files?.map((file, index) => (
                                                                        <div key={index} className='uploadfil'>
                                                                            {file.type.startsWith('image/') ? (
                                                                                <img
                                                                                    src={URL.createObjectURL(file)}
                                                                                    alt="Preview"
                                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                                />
                                                                            ) : (
                                                                                <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                                                            )}
                                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                        </div>
                                                                    ))}
                                                                </div> */}

                                                            </div>

                                                        </Col>
                                                        <Col sm="6">
                                                            <div className='missing_info order_item h-100'>
                                                                <div className='infobox'>
                                                                    <h4>Truck Information - Summary</h4>
                                                                    <p>Select a booking or ad-hoc truck</p>
                                                                    <ul>
                                                                        {/* <li>
                                                                            <p>
                                                                                <span>Truck Type: </span>
                                                                                <span> {localFormData.type_of_truck == 'B' ? 'Boocking Truck' : 'Ad Hoc'}</span>
                                                                            </p>
                                                                        </li> */}
                                                                        <h2 className='mt-2'>{localFormData.type_of_truck == 'B' ? 'BookingTruck Details' : 'Add Hoc Details'} </h2>
                                                                        {localFormData.type_of_truck == 'B' ? (
                                                                            <>
                                                                                {/* {localFormData.bookingTruck_type == 'E' ? ( */}
                                                                                <>
                                                                                    <li>
                                                                                        <span>Bookingtruck No: </span>
                                                                                        <span> {localFormData?.coload[0]?.bookingtruck_no}</span>
                                                                                    </li>
                                                                                    {/* <li>

                                                                                            <span>Date: </span>
                                                                                            <span> {localFormData.new_schedule_data?.departure_date}</span>

                                                                                        </li> */}
                                                                                    <li>
                                                                                        <span>Boardpoint: </span>
                                                                                        <span> {localFormData.board_point}</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <span>Offpoint: </span>
                                                                                        <span> {localFormData.off_point}</span>
                                                                                    </li>
                                                                                </>
                                                                                {/* ) : ( */}
                                                                                {/* <>
                                                                                        <li>
                                                                                            <span>Truck Type: </span>
                                                                                            <span> {localFormData?.new_schedule_data?.booking_type == 'E' ? 'Export' : 'Import'}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Bookingtruck No: </span>
                                                                                            <span> {localFormData.new_schedule_data?.bookingtruck_no}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Boardpoint: </span>
                                                                                            <span> {localFormData.boardpoint_name}</span>

                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Boardpoint Address: </span>
                                                                                            <span> {localFormData.boardpoint_address_name}</span>
                                                                                        </li>

                                                                                        <li>
                                                                                            <span>Offpoint: </span>
                                                                                            <span> {localFormData.offpoint_name}</span>

                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Offpoint Address: </span>
                                                                                            <span> {localFormData.offpoint_address_name}</span>

                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Trip Type: </span>
                                                                                            <span> {localFormData.new_schedule_data?.trip_type === 'O' ? 'One-Off' : localFormData.new_schedule_data?.trip_type === 'F' ? 'Frequent' :
                                                                                                localFormData.new_schedule_data?.trip_type === 'O' ? 'One-Off' : 'Frequent'}</span>
                                                                                        </li>
                                                                                        {localFormData.new_schedule_data?.trip_type == 'O' ? (
                                                                                            <>
                                                                                                <li>
                                                                                                    <span>Departure Date: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.departure_date}</span>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span>Departure Time: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.departure_time}</span>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span>Est. Travel Time: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.travel_time}</span>
                                                                                                </li>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <li>
                                                                                                    <span>Days: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.selected_days && localFormData.new_schedule_data?.selected_days.length > 0 ? (
                                                                                                        localFormData.new_schedule_data?.selected_days
                                                                                                            .map(code => dayNames[code])
                                                                                                            .join(', ')
                                                                                                    ) : (
                                                                                                        'No selected days'
                                                                                                    )}</span>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span>Bookingtruck Start Date: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.start_date}</span>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span>Bookingtruck End Date: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.end_date}</span>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span>Departure Time: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.departure_time}</span>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span>Est. Travel Time: </span>
                                                                                                    <span> {localFormData.new_schedule_data?.travel_time}</span>

                                                                                                </li>
                                                                                            </>
                                                                                        )}
                                                                                    </> */}
                                                                                {/* )} */}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <li>
                                                                                    <span>Boardpoint: </span>
                                                                                    <span> {localFormData.board_point}</span>
                                                                                </li>
                                                                                <li>
                                                                                    <span>Boardpoint Address: </span>
                                                                                    <span> {localFormData.boardpoint_address_name}</span>
                                                                                </li>
                                                                                {localFormData.new_schedule_data?.viapoints?.map((point) => (
                                                                                    <>
                                                                                        <li>
                                                                                            <span>Viapoint: </span>
                                                                                            <span> {point.viaStations.find(pt => pt.id === point.viaPoint).station_code}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Viapoint Address: </span>
                                                                                            <span> {point.viaAddress.find(pt => pt.id === point.viaPointAddress).handler_name} - {point.viaAddress.find(pt => pt.id === point.viaPointAddress).address_1}</span>
                                                                                        </li>
                                                                                    </>
                                                                                ))}

                                                                                <li>
                                                                                    <span>Offpoint: </span>
                                                                                    <span> {localFormData.off_point}</span>
                                                                                </li>
                                                                                <li>
                                                                                    <span>Offpoint Address: </span>
                                                                                    <span> {localFormData.offpoint_address_name}</span>
                                                                                </li>
                                                                                {/* <li>
                                                                                    <span>Departure Date Time: </span>
                                                                                    <span> {localFormData?.departure_date_time.split('T')[0]} {localFormData?.departure_date_time.split('T')[1]}</span>

                                                                                </li>
                                                                                <li>
                                                                                    <span>Arrival Date Time: </span>
                                                                                    <span> {localFormData?.arrival_date_time.split('T')[0]} {localFormData?.arrival_date_time.split('T')[1]}</span>

                                                                                </li> */}
                                                                                {/* <li>
                                                                                    <span>Est. Travel Time: </span>
                                                                                    <span> {localFormData.new_schedule_data?.travel_time}</span>
                                                                                </li> */}
                                                                            </>
                                                                        )}
                                                                    </ul>
                                                                    <hr />
                                                                    <ul>
                                                                        <h2 className='mt-2'>Operational Truck Specifications</h2>
                                                                        <li>
                                                                            <span>Operational Truck No: </span>
                                                                            <span>{localFormData.truck_no}</span>
                                                                        </li>
                                                                        <li>

                                                                            <span>Departure Date Time: </span>
                                                                            <span>{localFormData?.departure_date_time?.split('T')[0]} {localFormData?.departure_date_time?.split('T')[1]}</span>

                                                                        </li>
                                                                        <li>

                                                                            <span>Arrival Date Time: </span>
                                                                            <span>{localFormData?.arrival_date_time?.split('T')[0]} {localFormData?.arrival_date_time?.split('T')[1]}</span>

                                                                        </li>
                                                                        <li>
                                                                            <span>Truck Load: </span>
                                                                            <span>{localFormData.service_type_ == "F" ? 'FLT' : 'LTL'}</span>
                                                                        </li>
                                                                        <li>

                                                                            <span>Temperature Controled: </span>
                                                                            <span>
                                                                                {localFormData.temperature_control === "N" ? 'NO' :
                                                                                    localFormData.temperature_control === "TC" ? 'YES' + ' ' :
                                                                                        localFormData.temperature_control === "MC" ? 'Multiple Control ' : ''}
                                                                                {localFormData.temperature_control === 'MC' ? (<>
                                                                                    <label> ({localFormData.temperature_range_two_start}°C - {localFormData.temperature_range_two_end}°C) </label>
                                                                                    <label> ({localFormData.temperature_range_three_start}°C - {localFormData.temperature_range_three_end}°C)</label>
                                                                                </>
                                                                                ) : localFormData.temperature_control === 'TC' ? (
                                                                                    <>
                                                                                        <span> ({localFormData.temperature_range_one_start}°C - {localFormData.temperature_range_one_end}°C)</span>
                                                                                    </>
                                                                                ) : (<></>)}
                                                                            </span>
                                                                        </li>
                                                                        <li>
                                                                            <span>Number off Drivers: </span>
                                                                            <span>{localFormData.driver_number}</span>
                                                                        </li>
                                                                        <li>
                                                                            <span>ADR Required: </span>
                                                                            <span>{localFormData.adr == "1" ? 'YES' : 'NO'}</span>
                                                                        </li>
                                                                        <li>
                                                                            <span>Truck Material: </span>
                                                                            <span>
                                                                                {localFormData.truck_material === "HC" ? 'Hard Cover' :
                                                                                    localFormData.truck_material === "CS" ? 'Curtain Slider' :
                                                                                        localFormData.truck_material === "FT" ? 'Flatbed Trailer' : ''}
                                                                                <> (</>
                                                                                {localFormData.extra_truck_specification?.map((item, index) => (
                                                                                    <>{index != 0 && ', '}{item}</>
                                                                                ))}<>)</>
                                                                            </span>
                                                                            {/* {localFormData.extra_truck_specification?.map((item, index) => (
                                                                                <p className='mb-0' key={index}>{index + 1}. {item}</p>
                                                                            ))} */}

                                                                        </li>
                                                                        <li>
                                                                            <span>Min. Truck Height: </span>
                                                                            <span>{localFormData.truck_height}cm</span>
                                                                        </li>
                                                                        <li>
                                                                            <span>Rollerbed: </span>
                                                                            <span>{localFormData.rollerbed == "Y" ? 'YES' : 'NO'}</span>
                                                                        </li>
                                                                        <li>
                                                                            <span>Remarks: </span>
                                                                            <span>{localFormData.remarks}</span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Form.Group>
                                                </>
                                            }
                                            {/* <div className='ordernext'>
                                                {activeStep != 0 &&
                                                    <Button onClick={stepBack} variant="contained">
                                                        Back
                                                    </Button>
                                                }
                                                <Button className='trnext' variant="contained" onClick={activeStep === steps.length - 1 ? handleFinish : stepNext}>
                                                    {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                </Button>
                                            </div> */}
                                            <div className='ordernext'>
                                                {activeStep > 0 && (
                                                    <Button onClick={stepBack} variant="contained">Back</Button>
                                                )}

                                                <Button
                                                    className='trnext'
                                                    variant="contained"
                                                    onClick={activeStep === steps.length - 1 ? handleFinish : stepNext}
                                                >
                                                    {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                </Button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default OrderTruck;